function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
(function ($) {
  var fields_are_initialized = false;
  var initialized_repeaters_count = 0;
  function add_field_label_event($label, $input) {
    if (!$input.length) {
      return;
    }
    if ('' !== $input.val()) {
      $label.addClass('active');
    }
    $label.on('click', function () {
      $input.focus();
    });
    $input.on('focus', function () {
      $label.addClass('active');
    }).on('focusout', function () {
      var value = $.trim($(this).val());
      if (value.length === 0 || $(this).val() === '(___) ___-____') {
        $label.removeClass('active');
      }
    });
  }
  function add_field_list_label_event($field) {
    var $groups = $field.find('.gfield_list_groups');
    var $first_input = $groups.find('.gfield_list_group:first-child').find('input').first();
    var $label = $field.find('.gfield_label');
    if (1 < $groups.length || $first_input.length && '' !== $first_input.val()) {
      $label.addClass('active');
    }
    $field.on('focus', 'input', function () {
      $label.addClass('active');
    }).on('focusout', 'input', function () {
      var $input = $(this);
      var $parent_groups = $input.parents('.gfield_list_groups').children('.gfield_list_group');
      if (1 >= $parent_groups.length && '' === $(this).val()) {
        $label.removeClass('active');
      }
    });
  }
  function make_fselect_ids_unique($fselect) {
    var $labels = $fselect.find('.vtx-fselect__dropdown__options__label');
    var id_suffix = Math.random().toString(36).substr(2, 9);
    $labels.each(function () {
      var $label = $(this);
      var new_input_id = "".concat($label.attr('for'), "-").concat(id_suffix);
      $label.attr('for', new_input_id);
      $label.prev('input').attr('id', new_input_id);
    });
  }
  function add_repeater_field_item_label_events($repeater_field_item) {
    $repeater_field_item.find('.gfield_repeater_cell').each(function () {
      var $field = $(this);
      var $label = $field.find('.gfield_label');
      var $input = $field.find('.ginput_container input');

      // In case any leftovers are there. They will be put back on afterward anyway if some were rightful.
      $label.removeClass('active');
      add_field_label_event($label, $input);
    });
  }
  function add_repeater_field_item_fselect_events($repeater_field_item) {
    if (!$repeater_field_item.hasClass('cloned-repeater-item-not-init')) {
      // BAIL. Already initialized.
      return;
    }
    var $fselects = $repeater_field_item.find('.vtx-fselect');
    if (!$fselects.length) {
      // BAIL. No fselects in this item.
      return;
    }

    // These are clones. Remove all impression that they are initialized.
    $fselects.removeClass('is-initialized');
    $fselects.each(function () {
      var $fselect_field = $(this);
      make_fselect_ids_unique($fselect_field);
      var new_fselect = VTX_FSelect.new_fselect($fselect_field);
      if (new_fselect) {
        new_fselect.init();
        // new_fselect.on('open', function () {
        //   console.log(this);
        //   this.close();
        // }.bind(new_fselect));
      }
    });
  }
  function add_repeater_field_item_events($repeater_field_item) {
    add_repeater_field_item_label_events($repeater_field_item);
    add_repeater_field_item_fselect_events($repeater_field_item);
  }
  function clean_cloned_repeater_items() {
    $repeater_items.removeClass(['cloned-repeater-item-not-init', 'gfield_error']);
  }
  function get_form_by_id(form_id) {
    return $('#gform_wrapper_' + form_id);
  }
  function init_gform_repeater_btns($form) {
    var $add_btns = $form.find('.add_repeater_item');
    if ($add_btns.length) {
      $add_btns.attr('onclick', '').attr('onkeypress', '');
    }
    var $remove_btns = $form.find('.remove_repeater_item');
    if ($remove_btns.length) {
      $remove_btns.attr('onclick', '').attr('onkeypress', '');
    }
  }
  function disable_repeaters_delete_btn() {
    $('.remove_repeater_item').addClass('disabled');
  }
  function enable_repeaters_delete_btn() {
    $('.remove_repeater_item').removeClass('disabled');
  }
  function init_repeater_field($repeater_field) {
    var $repeater_items = $repeater_field.find('.gfield_repeater_item');
    if (!$repeater_items.length) {
      // BAIL. Already initialized.
      return;
    }
    add_repeater_field_item_events($repeater_items);
    // add_repeater_field_item_label_events($repeater_items);
    // make_unique_id_for_fselect_fields_in_repeater_field($repeater_items);

    if ($repeater_items.hasClass('cloned-repeater-item-not-init')) {
      clean_cloned_repeater_items($repeater_items);
    }
  }
  function init_gform_repeater_events($form) {
    // Add buttons events
    $(document).on('mouseup keyup', '.add_repeater_item', function (event) {
      if (0 === event.button || 'Enter' === event.key) {
        var $target = $(this);
        var $repeater_field_item = $target.closest('.gfield_repeater_item');

        // When activating add repeater item button.
        // This repeater item gets cloned.
        // We add right away this class and remove it after the cloning so we can know which one is really new.
        // (?) Actually not really used except to help debug. (?)
        $repeater_field_item.addClass('cloned-repeater-item-not-init');
        gformAddRepeaterItem(this);
        add_repeater_field_item_events($repeater_field_item.next('.gfield_repeater_item'));
        init_gform_repeater_btns($form);

        // As said ealier, remove this class as this repeater item is not new.
        $repeater_field_item.removeClass('cloned-repeater-item-not-init');
        $('html, body').stop().animate({
          scrollTop: $target.offset().top - get_header_height() - 50
        }, 500, function () {
          return false;
        });
      }
    });

    // Remove buttons events
    $(document).on('mouseup keyup', '.remove_repeater_item', function (event) {
      var $btn = $(this);
      if (!$btn.hasClass('disabled') && (0 === event.button || 'Enter' === event.key)) {
        disable_repeaters_delete_btn();
        $(this).parents('.gfield_repeater_item').slideUp(300, function () {
          gformDeleteRepeaterItem(this);
          setTimeout(function () {
            enable_repeaters_delete_btn();
          }, 500);
        });
      }
    });
    $(document).on('mouseover focus', '.remove_repeater_item', function () {
      $(this).parents('.gfield_repeater_item').addClass('delete-btn-hovered');
    });
    $(document).on('mouseout focusout', '.remove_repeater_item', function () {
      $(this).parents('.gfield_repeater_item').removeClass('delete-btn-hovered');
    });
  }
  function add_gform_events($form) {
    $form.on('submit', function () {
      this.classList.add('is-loading');
    });
    $form.find('.gfield:not(.gfield--repeater)').each(function () {
      var $field = $(this);
      if ($field.hasClass('initialized')) {
        return;
      }
      $field.addClass('initialized');
      if ($field.hasClass('gfield--list')) {
        add_field_list_label_event($field);
      } else {
        var $label;
        var $input;
        if ($field.hasClass('gfield--has-multiple-inputs')) {
          $field.find('.ginput_complex > span').each(function () {
            var $deeper_field = $(this);
            if (!$deeper_field.hasClass('initialized')) {
              $deeper_field.addClass('initialized');
              $label = $deeper_field.find('label');
              $input = $deeper_field.find('input, textarea');
            }
          });
        } else {
          $label = $field.find('.gfield_label');
          $input = $field.find('.ginput_container input , .ginput_container textarea');
        }
        if ($input) {
          add_field_label_event($label, $input);
        }
      }
    });
    init_repeater_field($form.find('.gfield--repeater'));
  }

  /**
   * Gravity Form got a problem with giving focus to the right form after an error.
   * This fixes this a bit.
   */
  function check_if_gform_needs_focus($form) {
    if ($form.length && $form.find('.validation_error').length) {
      setTimeout(function () {
        this.find('.gfield_error input, .gfield_error textarea').first().focus();
      }.bind($form), 100);
    }
  }
  function clean_gform_classes($form) {
    $form.removeClass('is-loading');
  }
  function add_woocommerce_form_events() {
    $('.woocommerce .form-row').each(function () {
      var $field = $(this);
      var $label = $field.find('label');
      var $input = $field.find('.woocommerce-input-wrapper input, .woocommerce-input-wrapper textarea');
      add_field_label_event($label, $input);
    });
  }
  $(document).on('gform_post_render', function (event, form_id, current_page) {
    var $form = get_form_by_id(form_id);
    if (!$form.length) {
      // BAIL. That form does not exist
      return;
    }
    clean_gform_classes($form);
    add_gform_events($form);
    check_if_gform_needs_focus($form);
    init_gform_repeater_btns($form);
    if (!fields_are_initialized) {
      fields_are_initialized = true;
      init_gform_repeater_events($form);
    }
  });

  ///// READY /////
  $(function () {
    add_woocommerce_form_events();
  });
  var searchLoadMoreButton = document.getElementById('search-load-more');
  if (searchLoadMoreButton) {
    searchLoadMoreButton.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var nextPage, response, html, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            nextPage = parseInt(searchLoadMoreButton.dataset.page) + 1;
            searchLoadMoreButton.disabled = true;
            searchLoadMoreButton.textContent = searchLoadMoreButton.dataset.loading;
            _context.p = 1;
            _context.n = 2;
            return fetch('/wp-admin/admin-ajax.php', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: new URLSearchParams({
                action: 'load_more_button',
                searchtype: searchLoadMoreButton.dataset.searchtype,
                page: nextPage,
                search: searchLoadMoreButton.dataset.search ? searchLoadMoreButton.dataset.search : '',
                posttype: searchLoadMoreButton.dataset.posttype ? searchLoadMoreButton.dataset.posttype : '',
                firstletter: searchLoadMoreButton.dataset.firstletter ? searchLoadMoreButton.dataset.firstletter : '',
                taxfilter: searchLoadMoreButton.dataset.taxfilter ? searchLoadMoreButton.dataset.taxfilter : '',
                lang: searchLoadMoreButton.dataset.lang ? searchLoadMoreButton.dataset.lang : 'fr'
              })
            });
          case 2:
            response = _context.v;
            _context.n = 3;
            return response.text();
          case 3:
            html = _context.v;
            if (html.trim() !== '') {
              document.getElementById('load-more-results').insertAdjacentHTML('beforeend', html);
              if (html.includes('<!-- last-page -->')) {
                searchLoadMoreButton.remove();
              } else {
                searchLoadMoreButton.dataset.page = nextPage;
                searchLoadMoreButton.disabled = false;
                searchLoadMoreButton.textContent = searchLoadMoreButton.dataset.text;
              }
            } else {
              searchLoadMoreButton.remove();
            }
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            console.error(_t);
            searchLoadMoreButton.disabled = false;
            searchLoadMoreButton.textContent = searchLoadMoreButton.dataset.text;
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 4]]);
    })));
  }
})(jQuery);